import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import styles from "./CategorySlider.module.css";

export default function CategorySlider() {
  const navigate = useNavigate();
  const [sliderImages, setSliderImages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSliderImages();
  }, []);

  async function fetchSliderImages() {
    try {
      setLoading(true);
      const { data } = await axios.get(
        "https://api.elza2.store/api/v1/slider"
      );
      setSliderImages(data.sliders || data);
    } catch (error) {
      console.error("Error fetching slider images:", error);
      // Fallback to empty array on error
      setSliderImages([]);
    } finally {
      setLoading(false);
    }
  }

  async function handleNavigate(category) {
    if (category === "custom") {
      navigate(`/custom`);
      return;
    }
    navigate(`/Products?category=${category}`);
  }

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    cssEase: "linear",
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  if (loading) {
    return (
      <div className={styles.sliderContainer}>
        <div className={styles.loading}>Loading slider...</div>
      </div>
    );
  }

  if (!sliderImages || sliderImages.length === 0) {
    return null;
  }

  return (
    <div className={styles.sliderContainer}>
      <Slider {...settings}>
        {sliderImages.map((image, index) => (
          <div key={image._id || index} className={styles.sliderItem}>
            {image._id !== "DiscountCode" && (
              <button
                className={styles.navigateButton}
                onClick={() => handleNavigate(image.category)}
              >
                View {image.title || image.category}
              </button>
            )}
            <img src={image.image} alt={`Slider Image ${index + 1}`} />
          </div>
        ))}
      </Slider>
    </div>
  );
}